export const PRESCRIBERS_FIND_ALL_QUERY_NAME = "Prescribers";
export const PRESCRIBERS_BY_INSTITUTION_QUERY_NAME =
  "getAllPrescribersByInstitution";
